import { createMuiTheme } from '@material-ui/core/styles';
import teal from '@material-ui/core/colors/teal';

const theme = createMuiTheme({

    fontFamily: 'Helvetica',
    palette: {
        primary: {
            main: teal[700],
            contrastText: '#ffffff',
        },
        secondary: {
            main:'#76b5b8',
        }
    },
});


export default theme;


// WEBPACK FOOTER //
// ./assets/src/js/components/themes/base.js